import { MyLogger } from '@marketplace/mylogger';
import { navigateToUrl, registerApplication, start } from 'single-spa';
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from 'single-spa-layout';

import { initializeData } from './bootstrap/context';
import { getRoutesConfig } from './layout';

import '@tabler/core/dist/css/tabler-vendors.min.css';
import '@tabler/core/dist/css/tabler.min.css';
import { autoRedirectTo, removeMainLoading } from './utils';

MyLogger.run();

const renderLayout = async () => {
  const [contextData] = await Promise.all([initializeData()]);
  if (!contextData) return;

  const routesConfig = getRoutesConfig();
  const resolvedRoutes = constructRoutes(routesConfig);
  const applications = constructApplications({
    routes: resolvedRoutes,
    loadApp: async ({ name }) => {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({
    routes: resolvedRoutes,
    applications,
  });

  if (contextData?.user.get()?.user === undefined) {
    if (!window.location.pathname.includes('auth')) {
      navigateToUrl('/auth');
    }
  } else {
    if (window.location.pathname.includes('auth')) {
      navigateToUrl('/dashboard');
    }
  }

  applications.forEach(registerApplication);
  layoutEngine.activate();

  autoRedirectTo();
  removeMainLoading();
};

renderLayout();
start();

require('@tabler/core/dist/js/tabler');
